import { render } from "./DeviceDetail.vue?vue&type=template&id=03820b74"
import script from "./DeviceDetail.vue?vue&type=script&lang=js"
export * from "./DeviceDetail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__